export default __webpack_public_path__ + "static/1.1_FR-20a1b0e7078e54dcdbfe83b5e33e89b1.webp";